import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import ProductCard from './ProductCard';
import { Typography } from '@material-ui/core';
import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';

import {
  getPromocode,
  updateCartCoupon,
  updateCartObjLocal,
  emptyCart,
  getCartItems,
  verifyCouponCode
} from '../../../store/actions/user/User';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import SignDialog from '../SignIn/SignDialog';
import CheckoutForm from '../Checkout/CheckoutForm';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';

var promocode = '';
var message = ''
const useStyles = makeStyles((theme) => ({
  list: {
    width: 400,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    }
  },
  fullList: {
    width: 'auto'
  },
  checkoutAction: {
    display: 'flex',
    justifyContent: 'space-around'
  },
  checkoutFooter: {
    justifyContent: 'center'
  },
  clearCart: {
    background: '#fff',
    border: '1px solid',
    borderRadius: '20px'
  }
}));

const SideCart = (props) => {
  const classes = useStyles();
  const [state, setState] = React.useState({
    right: false,
    promocode: 'Promo code not valid',
    color: 'red',
    flag: false,
    msg: '',
    disabled: false,
    show: false
  });
  const [coupon, setCoupon] = React.useState({});
  const [formOpen, setForm] = React.useState({ open: false });
  const [openCheckout, toggleChekout] = useState(false);
  useEffect(() => {
    if (props.coupon) {
      setCoupon(props.coupon)
      if (props.auth) {
        let carts = props.cart
        carts.map((c) => {
          c.coupon = props.coupon
        })
        props.updateCartCoupon(carts)
      }
      else
        props.updateCartObjLocal(props.coupon)
    }
  }, [props.coupon]);

  const handlePromocode = (e) => {
    setState({ ...state, promocode: e.target.value });
  };

  const handleSubmit = (event) => {
    const { verifyCouponCode, cart } = props
    verifyCouponCode({ product: cart[0].products[0], couponCode: state.promocode })
  };
  const handleSignOpen = () => {
    setForm({ open: true });
  };
  const handleSignClose = () => {
    setForm({ open: false });
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, right: open });
  };
  const handleOpenDialog = () => {
    props.onClose();
    // toggleChekout(true);
    // setDialog({ openDialog: true });
  };

  const auth = props.auth;
  let c = 0;
  let variant_price = 0;
  const total = props.cart
    ? props.cart.map(
      (item) => (c += parseFloat(item.products[0]?.isOffer ? item.products[0]?.offerPrice : item.products[0]?.price) * (item.products[0].isGm || item.products[0].isMl ? item.quantity / 10 : item.quantity))
    )
    : 0;
  const total_variant = props.cart
    ? props.cart.map(
      (item) => (
        item.variant && item.variant.map((v) =>
          variant_price += parseFloat(v.price) * (item.products[0].isGm || item.products[0].isMl ? item.quantity / 10 : item.quantity)
        )
      )
    )
    : 0;
  const t = (total[total.length - 1] + variant_price).toFixed(2);
  const pc = coupon && coupon.discountType ? coupon : (props.cart && props.cart.length > 0 ? props.cart[0].coupon : {});
  var gt = 0;
  var p;
  if (pc && pc.discountType === 'FIXED') {
    p = pc.value;
    gt = t - p;
  } else if (pc && pc.discountType === 'PERCENTAGE') {
    p = (pc.value * t) / 100;
    gt = t - p;
  } else if (pc && pc.discountType !== undefined) {
    p = 0;
    gt = t;
  } else {
    p = 0;
    gt = t;
  }
  if (gt < 0) {
    gt = 0
  }
  localStorage.setItem('totalCost', gt);
  localStorage.setItem('promoCost', p);
  localStorage.setItem('cost', t);
  localStorage.setItem('coupon', JSON.stringify(pc));

  const clearTheCart = () => {
    props.emptyCart().then((data) => {
      props.getCartItems();
    });
  };

  const list = (anchor) => (
    <>
      {openCheckout ? (
        <CheckoutForm handleSideBar={handleCloseSidebar} />
      ) : (
          <div
            className={clsx(classes.list, {
              [classes.fullList]: anchor === 'top' || anchor === 'bottom'
            })}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
          >
            {/* <CheckoutDialog
            open={dialogAction.openDialog}
            onClose={handleCloseDialog}
            total={gt}
          ></CheckoutDialog> */}
            <Typography
              variant="h5"
              style={{ margin: '10px', fontWeight: '600' }}
              align="center"
            >
              <span style={{ float: 'left' }}><IconButton onClick={handleCloseSidebar}><CloseIcon /></IconButton></span> Your Cart
          </Typography>
            <Divider></Divider>
            {props?.vendorWiseCart?.map((vendor) => {
              return (<><div style={{ width: '100%', marginLeft: '3%', display: 'flex', justifyContent: 'left' }}><Typography
                variant="span"
                style={{
                  fontWeight: '500', marginTop: '2%',
                  marginBottom: '2%',
                  fontSize: '19px'
                }}
                align="left">{vendor.name}</Typography>
              </div>
                <Divider></Divider>
                {vendor.cart.map((item) => {
                  return (<><ProductCard about={item}></ProductCard>
                    <Divider></Divider></>)
                })
                }</>
              )
            })}
            {props?.cart?.length > 0 ? (
              <>
                <div style={{ display: 'flex', padding: '30px' }}>
                  <Typography style={{ paddingRight: '5px' }}>
                    <b style={{ color: '#000' }}>SubTotal:</b> AUD {!t ? 0 : t}
                  </Typography>
                  <Typography style={{ paddingRight: '5px' }}>
                    <b style={{ color: '#000' }}>Discount:</b> AUD {p}
                  </Typography>
                  <Typography style={{ paddingLeft: '35px' }}>
                    <b style={{ color: '#000' }}>Price:</b> AUD {!gt ? 0 : gt}
                  </Typography>
                </div>
                {props?.vendorWiseCart?.length <= 1 &&
                  <div className="row" style={{ display: "flex", padding: "30px" }}>
                    <div className="col-9">
                      <TextField
                        margin="normal"
                        required
                        fullWidth
                        label="PromoCode"
                        error={message == "Promo code is not valid"}
                        name="promocode"
                        onChange={handlePromocode}
                        helperText={message}
                      />
                    </div>
                    <div className="col-3">
                      <Button
                        className="btnAdd" style={{ background: 'rgb(1, 160, 90)', color: 'white', marginTop: '36%' }}
                        id="promocode"
                        name="promocode"
                        onClick={handleSubmit}
                      >
                        Apply
                  </Button>
                    </div>
                  </div>
                }
                <br></br>
                <Typography
                  component="div"
                  align="center"
                  display="flex"
                  className={classes.checkoutFooter}
                >
                  {auth ? (
                    <div className={classes.checkoutAction}>
                      <NavLink to="/cart-checkout" style={{ textDecoration: 'none' }}>
                        <Button className="btnAdd" style={{ background: 'rgb(1, 160, 90)', color: 'white' }} onClick={handleOpenDialog}>
                          Checkout
                        </Button>
                      </NavLink>
                      <Button
                        className={classes.clearCart}
                        onClick={clearTheCart}
                      >
                        Clear Cart
                    </Button>
                    </div>
                  ) : (
                      <div className={classes.checkoutAction}>
                        <NavLink to="/cart-checkout" style={{ textDecoration: 'none' }}>
                          <Button className="btnAdd" style={{ background: 'rgb(1, 160, 90)', color: 'white' }} onClick={handleOpenDialog}>
                            Checkout
                    </Button>
                        </NavLink>
                      </div>
                    )}
                </Typography>

              </>
            ) : (
                <Typography variant="h5" align="center" style={{ padding: '20px' }}>
                  Nothing In Your Cart
                </Typography>
              )}
          </div>
        )
      }
    </>
  );

  const handleCloseSidebar = () => {
    toggleChekout(false);
    props.onClose();
  };

  return (
    <div>
      <SignDialog open={formOpen.open} onClose={handleSignClose}></SignDialog>
      <React.Fragment>
        <Drawer anchor={'right'} open={props.open} onClose={handleCloseSidebar}>
          {list('right')}
        </Drawer>
      </React.Fragment>
    </div>
  );
};
const mapStateWithProps = (state) => ({
  cart: state.user.cart,
  vendorWiseCart: state.user.vendorWiseCart,
  promocode: state.user.promocode,
  auth: state.user.auth,
  coupon: state.user.coupon
});

const mapDispatchToProps = (dispatch) => ({
  getPromocode: () => dispatch(getPromocode()),
  emptyCart: () => dispatch(emptyCart()),
  updateCartCoupon: (product) => dispatch(updateCartCoupon(product)),
  updateCartObjLocal: (product) => dispatch(updateCartObjLocal(product)),
  getCartItems: () => dispatch(getCartItems()),
  verifyCouponCode: (data) => dispatch(verifyCouponCode(data))
});

export default connect(mapStateWithProps, mapDispatchToProps)(SideCart);
